export default __webpack_public_path__ + "static/media/advisory.502bf87f.svg";